import { render, staticRenderFns } from "./ProductCollection.vue?vue&type=template&id=6e1a5556&scoped=true&"
import script from "./ProductCollection.vue?vue&type=script&lang=js&"
export * from "./ProductCollection.vue?vue&type=script&lang=js&"
import style0 from "./ProductCollection.vue?vue&type=style&index=0&id=6e1a5556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1a5556",
  null
  
)

export default component.exports